module.exports = __webpack_public_path__ + "img/meal.ab83d367.png";